import { linkToTeacherDashboard } from "../../links";

export function linkToTeacherHomepage() {
  return `${linkToTeacherDashboard()}/home`;
}

export function linkToTeacherFeedback() {
  return `${linkToTeacherHomepage()}/feedback`;
}

export function linkToMiSInfoModal() {
  return `${linkToTeacherHomepage()}/mis-sync-info`;
}
